import logsService from "../services/logs.service";

export const sendLogs = async (payload) => {
  return await logsService.sendLogs(payload).then((resp) => {
    return Promise.resolve();
  });
};
